import { useEffect, useState } from "react";
import "./App.css";
import { Container, Stack} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Header from "./components/Header";
import LanguageSwitch from "./components/LanguageSwitch";
import { formatDate } from "./util/util";
import build from "./build.json";
import { AppInfo, Page } from "./config/types";
import PageFactory from "./components/factories/PageFactory";
import { useDedupEffect } from "./util/useDedupEffect";
import { Link, redirect, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { AwsRum, AwsRumConfig } from 'aws-rum-web';

//import JsonEditorComponent from "./components/jsonEditor";
import {
  getInputConfig,
  getLocale,
  getBuildInfo,
  getInstallerInfo,
  getManifestInfo,
  getMsiBuildInfo,
  getMsiInstallerInfo,
  getMaintenance,
  maintenanceType
} from "./services/data.service";
import { NdtInput } from "@npd-ng/network-diagnostic-tool";

function App() {
  const navigate = useNavigate();
  const pageId = useParams().pageId;
  const language = useParams().language;
  const subSectionId = useParams().subSectionId;
  const accordionId = useParams().accordionId;
  const [pageSelected, setpageSelected] = useState("getting-started");
  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams()
  const [maintenance, setMaintenance] = useState(false);
  const defaultLang = {
    es: {} as AppInfo,
    en: {} as AppInfo,
  };
  const skipMaintenance = new URL(window.location.href).searchParams.get(
    "skipMaintenance"
  );
  const [appData, setAppData] = useState(defaultLang);
  const [loading, setLoading] = useState(true);
  // const appDataEs: AppInfo = renderData as AppInfo;

  const [version, setVersion] = useState("");
  const [versionColor, setVersionColor] = useState("");
  const [versionBorderColor, setVersionBorderColor] = useState("");
  const [releaseDate, setReleaseDate] = useState("");
  const [installerName, setInstallerName] = useState("");
  const [msiInstallerName, setMsiInstallerName] = useState("");
  const [msiArtifactName, setMsiArtifactName] = useState("");
  const [inputConfig, setInputConfig] = useState<NdtInput>();
  const [installerInfo, setInstallerInfo] = useState({
    installerName: "",
    size: "(0MB)",
    installerPath: "",
    uninstallGuid: "",
  });
  const [msiInstallerInfo, setMsiInstallerInfo] = useState({
    msiInstallerName: "",
    msiSize: "(0MB)",
    msiInstallerPath: "",
    msiAppVersion: "",
    uninstallGuid: "",
  });

  const renderTabs = () => {
    const pages =
      i18n.language === "en"
        ? (appData?.en?.pages as Page[])
        : (appData?.es?.pages as Page[]);
    const currentPage = pages?.find((page)=>page.pageId === pageId) || pages[0];
    return (
      <>
      <Stack direction="horizontal" gap={0} className="navbar">
        <div style={{paddingLeft:"50px"}}></div>
        {pages?.filter((page) => page.enabled)
          .map((page) => {
            return(
              <div className={pageId?.includes(page.pageId) ? "nav-tab-selected" : "nav-tab"} key={page.pageId}>
                <Link to={`/${i18n.language}/${page.pageId}?${searchParams}`} onClick={()=>{setpageSelected(page.pageId)}}key={page.pageId} style={{textDecoration:"none",color:"#fff"}}>{page.title}</Link>
              </div>
            )
          })
        }
      </Stack>
        <PageFactory
          pageData={currentPage}
          inputJson={inputConfig}
          version={version}
          versionColor={versionColor}
          versionBorderColor={versionBorderColor}
          releaseDate={releaseDate}
          installerName={installerName}
          installerInfo={installerInfo}
          msiInstallerName={msiInstallerName}
          msiInstallerInfo={msiInstallerInfo}
          msiArtifactName={msiArtifactName}
          build={build}
          selectedSubNavId={subSectionId}
          selectedAccordionId={accordionId}
          selectedPageId={pageSelected}
          resetPageSelected={()=>{setpageSelected("")}}
        />
      </>)
  };
  const getCurrentPage = () => {
    const pages =
      i18n.language === "en"
        ? (appData?.en?.pages as Page[])
        : (appData?.es?.pages as Page[]);
    const defaultPage = pages?.find((page)=>page.enabled === true);
    if (pageId) {
      const validatePage = pages?.find((page)=>page.pageId === pageId);
      if(pageId === "maintenance"){
        navigate(`/${i18n.language}/error/maintenance`);
      }
      if(!validatePage || pageId === "404"){
        navigate(`/${i18n.language}/error/404`);
      }
      if (subSectionId) {
        let validateSubSection =  undefined
        let validateAccordion = undefined
        validatePage?.subSections?.groups?.forEach(
          (groups)=>
            {
              groups.items.forEach(
                (item)=>{
                  if(subSectionId === item.sectionId)
                    {
                      validateSubSection = true;
                      if(accordionId !== undefined){
                        item.section.content.forEach((item)=>
                          {
                            if(item.key && accordionId === item?.key){
                              validateAccordion = true
                            }
                          }
                        )
                      }
                    }
                }) 
            });
        if(!validateSubSection){
          navigate(`/${i18n.language}/error/404`);
        }
        if(accordionId && !validateAccordion){
          navigate(`/${i18n.language}/error/404`);
        }
      }
      else if(pageId && !subSectionId){
        const currentPage = pages?.find((page)=>page.pageId === pageId); 
        currentPage?.subSections?.groups?.forEach((group)=>{
          group.items.forEach((item)=>{
            if(item.default){
              navigate(`/${i18n.language}/${pageId}/${item.sectionId}?${searchParams}`, {replace:true});
            }
          })
        })
      }
    } 
    else if (defaultPage) {
      navigate(`/${i18n.language}/${defaultPage.pageId}?${searchParams}`);
    }
    else {
      navigate(`/${i18n.language}/getting-started?${searchParams}`);
    }
    
  };
  const goToErrorPage = () => {
    console.error("Maintenance error we are unable to retreive the maintenance information.");
    navigate(`/${i18n.language}/error/404`);
  }
  useDedupEffect(() => {
    if (!document.location.toString().includes("ed.gov")) {
      const metaRobots = document.createElement("meta");
      metaRobots.name = "robots";
      metaRobots.content = "noindex";
      document.head.appendChild(metaRobots);
    }
    getLocale().then((locale) => {
      setAppData({ en: locale.en, es: locale.es });
      setLoading(false);
      i18n.addResources("en", "translation", locale.en);
      i18n.addResources("es", "translation", locale.es);
    });
    getInstallerInfo().then((results) => {
      console.info("Installer info is: ", results);
      setInstallerInfo(results);
    });
    getMsiInstallerInfo().then((results) => {
      console.info("Msi Installer info is: ", results);
      setMsiInstallerInfo(results);
    });
    getInputConfig().then((inputJson) => {
      console.log("input.json: ", inputJson);
      setInputConfig(inputJson);
    });
    getManifestInfo()
      .then(async (manifest) => {
        console.log("manifest is:", manifest);
        let exactVersion =
          ((manifest?.manifest?.product?.version).replace(
            /\.|MS|-/g,
            ""
          ) as any) % 16;
        setVersion(manifest?.manifest?.product?.version);
        setVersionColor(
          manifest?.manifest?.product?.versionColors[exactVersion]
        );
        setVersionBorderColor(
          manifest?.manifest?.product?.versionBorderColors[exactVersion]
        );
        const build = await getBuildInfo();
        console.log(build);
        const date = new Date(build.date);
        setReleaseDate(formatDate(date));
        //temporarily trying mini-installer which is only deployed to dev
        setInstallerName(build.installerName);
        const msiBuild = await getMsiBuildInfo();
        console.log(msiBuild);
        //temporarily trying mini-installer which is only deployed to dev
        setMsiInstallerName(msiBuild.installerName);
        setMsiArtifactName(msiBuild.artifactName);
        // setInstallerName('NAEPAssessmentDev26Setup.exe')
      })
      .catch((err) => {
        console.error("An error occurred trying to get the build.json", err);
      });
      console.log("skipMaintenance",skipMaintenance)
    if(!skipMaintenance){
      getMaintenance(goToErrorPage).then((maintenance:maintenanceType) => {
         if (maintenance.maintenance) {
           setMaintenance(true);
          }
      });
    }
  },[])


  useEffect(() => {
    if(language && (language === "en" || language === "es")){
      localStorage.setItem("preferredLanguage",language)
    }
    const preferredLanguage = localStorage.getItem('preferredLanguage');
    if (preferredLanguage) {
      i18n.changeLanguage(preferredLanguage);
    }
  }, [i18n,language]);
  useDedupEffect(() => {
    if(maintenance){
      navigate(`/${i18n.language}/error/maintenance`);
    }
    else{
      if(pageId && !subSectionId && !accordionId){
        setpageSelected(pageId);
      }
      if(appData.en.pages && appData.en.pages.length > 0 && appData.es.pages && appData.es.pages.length > 0){
        getCurrentPage();
      }
    }
  },[appData,pageId,subSectionId,accordionId,maintenance]);
  return (
    <>
      {!loading && (
        <div className="wrapper-container">
          <div id="ndtContainer"></div>
          {appData && (
            <>
              <Container
                fluid
                style={{
                  top: "0",
                  position: "relative",
                  padding: "0",
                  //  height: "calc(100vh - 4.5rem)",
                  backgroundColor: "whitesmoke",
                }}
              >
                <Header />
                <div className="navbar-n-section-wrapper">
                  <div className="sticky-language-section">
                    <LanguageSwitch
                      languageSupport={
                        i18n.language === "en"
                          ? appData.en.languageSupport
                          : appData.es.languageSupport
                      }
                    />
                  </div>
                  {renderTabs()}
                </div>

                <div className="version">
                  {t("version")}
                  {build?.version} {t("releaseDate")}
                  {formatDate(new Date(build?.date))}
                </div>
              </Container>
            </>
          )}
        </div>
      )}
    </>
  );
}
//<div className="footer"></div>
export default App;
